<template>
  <v-card elevation="5" max-width="max-content" style="text-align: left">
    <v-card-text>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-wrap">
              {{ $props.title }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-wrap">
              {{ $props.subtitle }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle class="text-wrap">
              {{ $props.third }} orders
            </v-list-item-subtitle>
            <v-list-item-title class="text-wrap">
              <a :href="'mailto:' + $props.description">
                {{ $props.description }}
              </a>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        width="100%"
        :href="$props.action"
        target="_blank"
        small
      >
        View Customer
        <v-icon small>mdi-open-in-new</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    props: ['title', 'subtitle', 'third', 'description', 'action'],
    data() {
      return {}
    }
  }
</script>
